import React, { useEffect, useState } from 'react';
import InputComponent from '../InputComponent';
import { Col } from 'reactstrap';
import { useTranslation } from 'react-i18next';

const PhoneNumber = (props) => {
    const [isValid, setIsValid] = useState(true);
    const { t } = useTranslation();

    useEffect(() => {
        if (props.disable && !props.assessmentCompleted) {
            props.changed('');
        }
    }, [props.disable, props.assessmentCompleted]);

    const onInputChanged = (e) => {
        const { value } = e.target;
        const digits = value.replace(/\D/g, '');

        let formattedValue = digits;
        if (value) {
            if (checkMobileValidate(digits)) {
                setIsValid(true);
            } else {
                setIsValid(false);
            }
        } else {
            setIsValid(true);
        }

        props.changed(formattedValue);
    };

    const checkMobileValidate = (digits) => {
        return digits.length === 10;
    };

    const getPlaceholder = () => {
        let placeholder = props.placeholder || props.questionText || 'Enter your phone number';
        if (props.isMandate) return `${placeholder} *`;
        return placeholder;
    };

    return (
        <React.Fragment>
            {props.type === 122 ? (
                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="pe-0 mt-0">
                    <>
                        <InputComponent
                            id={props.answerInternalIdentifier}
                            name={props.questionId}
                            value={props.value}
                            type="tel"
                            className={`w-100 ${!props.placeholder && !props.questionText ? 'input-default' : ''}`}
                            invalid={props.error?.[props.questionId]}
                            onChange={onInputChanged}
                            onBlur={() => props.handleOnBlur(isValid, 'mobileNumber')}
                            {...props}
                            maxLength={10} // Limit input length to 10 digits
                            disabled={props.disable}
                            placeholder={getPlaceholder()}
                        />
                        {!isValid && <p className="text-danger">{t('validNumber')}</p>}
                    </>
                </Col>
            ) : (
                <>
                    <InputComponent
                        id={props.answerInternalIdentifier}
                        name={props.questionId}
                        value={props.value}
                        type="tel"
                        className={`w-100 ${!props.placeholder && !props.questionText ? 'input-default' : ''}`}
                        placeholder={props.placeholder || props.questionText}
                        invalid={props.error?.[props.questionId]}
                        onChange={onInputChanged}
                        onBlur={() => props.handleOnBlur(isValid, 'mobileNumber')}
                        {...props}
                        maxLength={10} // Limit input length to 10 digits
                        disabled={props.disable}
                    />
                    {!isValid && <p className="text-danger">{t('validNumber')}</p>}
                </>
            )}
        </React.Fragment>
    );
};

export default PhoneNumber;
